import axios, { AxiosResponse } from 'axios';
import { clientData } from '../types/interfaces';
import {
  secureDelete,
  secureGet,
  securePost,
  securePut,
} from '../utils/HttpUtils';
import {
  buildApplicationClientFileUrl,
  buildClientFileUrl,
} from '../utils/fileStorageUrl';

const apiUrls = {
  clientData: '/v1/private/clients/',
  productLines: '/v1/private/productlines/',
  assets:'/v1/private/ai/assets',
  creditTypes: '/v1/private/application/credit-types',
};

export { buildClientFileUrl, buildApplicationClientFileUrl };

export const getClientInfo = async (cuit: string) => {
  const url = apiUrls.clientData + cuit;
  return secureGet(url);
};

export const saveClientInfo = async (
  clientData: clientData,
  cuit: string,
  id: number
) => {
  try {
    if (id) {
      const url = apiUrls.clientData + cuit + '/applications/' + id;
      return securePut(url, clientData);
    } else {
      const url = apiUrls.clientData + cuit;
      return securePut(url, clientData);
    }
  } catch (error) {
    console.error('Error saving client info:', JSON.stringify(error, null, 2));
    throw error;
  }
};

export const saveClientDocument = async (
  cuit: string | undefined,
  file: FormData
) => {
  const url = apiUrls.clientData + cuit + '/files';
  return securePost(url, file, 'multipart/form-data');
};

export const saveApplicationDocument = async (
  cuit: string | undefined,
  applicationId: string,
  file: FormData
) => {
  const url = apiUrls.clientData + cuit + '/applications/' + applicationId + '/files';
  return securePost(url, file, 'multipart/form-data');
};

export const saveSignerDocument = async (
  cuit: string | undefined,
  file: FormData
) => {
  const url = apiUrls.clientData + cuit + '/applications/files';
  return securePost(url, file, 'multipart/form-data');
};

export const downloadClientDocument = async (
  cuit: string | undefined,
  fileId: string | undefined
) => {
  const token = localStorage.getItem('token');
  try {
    const response: AxiosResponse = await axios.get(
      buildClientFileUrl(cuit, fileId),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const downloadApplicationDocument = async (
  cuit: string | undefined,
  applicationId: string,
  fileId: string | undefined
) => {
  const token = localStorage.getItem('token');
  try {
    const response: AxiosResponse = await axios.get(
      buildApplicationClientFileUrl(cuit, applicationId, fileId),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const deleteClientDocument = async (cuit: string | undefined, fileId: string) => {
  const url = buildClientFileUrl(cuit, fileId);
  return secureDelete(url);
};

export const getProductLines = async () => {
  const url = apiUrls.productLines;
  return secureGet(url);
};

export const getLufeCloudFiles = async (cuit: string) => {
  const url = apiUrls.clientData + cuit + '/cloud-documents/';
  return secureGet(url);
};

export const downloadLufeCloudFile = async (
  cuit: string,
  documentUrl: string
) => {
  const token = localStorage.getItem('token');
  try {
    const response: AxiosResponse = await axios.get(
      apiUrls.clientData + cuit + '/cloud-documents/' + documentUrl,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const loadAssets = async (file:FormData, index:number) => {

  //mocking the upload process
  const  url = apiUrls.assets ;
  
  return securePost(url, file, 'multipart/form-data');
}

export const getCreditTypes = async () => {
  const url = apiUrls.creditTypes;
  return secureGet(url);
};
